import { render, staticRenderFns } from "./MigrateWebsiteGroupDialog.vue?vue&type=template&id=61a7466d&"
import script from "./MigrateWebsiteGroupDialog.vue?vue&type=script&lang=ts&"
export * from "./MigrateWebsiteGroupDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports